const NAVBAR_HEIGHT = 56;

export default NAVBAR_HEIGHT;
